import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '@core/utils/styles';

const textVariants = cva('', {
  variants: {
    variant: {
      default: 'text-txt-light dark:text-txt-dark',
      muted: 'text-txt-light-muted dark:text-txt-dark-muted',
      primary: 'text-primary dark:text-primary-lightest',
      success: 'text-green-600 dark:text-green-400',
      warning: 'text-yellow-600 dark:text-yellow-400',
      danger: 'text-red-600 dark:text-red-400',
      white: 'text-white dark:text-white',
      none: '',
    },
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
    },
    weight: {
      light: 'font-light',
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'base',
    weight: 'normal',
    align: null,
  },
});

interface TextProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof textVariants> {
  as?: 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  selectable?: boolean;
}

export const Text = ({
  className,
  variant,
  size,
  weight,
  align,
  selectable = false,
  as: Component = 'p',
  children,
  ...props
}: TextProps) => {
  return (
    <Component
      className={cn(
        selectable ? 'select-text' : 'select-none',
        textVariants({ variant, size, weight, align }),
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
